import React, { forwardRef }  from 'react';

const MultipleCheckbox = forwardRef((props, ref) => {
    let url = props.data['name'].toLowerCase()?.split(" ").join("_");
    if(url[url.length-1] === '_') {
        url = url.slice(0, -1);
    }
    let checkbox_from_url = props.URL_PARAMS.get(url) ? props.URL_PARAMS.get(url).split(",") : [];

    let content=[];
    let id=`checkboxes${props.index}`;
    // const dropdown_default_value = props.URL_PARAMS.get(props.data['name']) ? props.URL_PARAMS.get(props.data['name'].toLowerCase().split(" ").join("_")).split("_").join(" ") || "" : "";

    if(typeof(props.data['content'])===undefined){
        return <div></div>
    }

    for(let y=0; y<props.data['content'].length; y++){
        content.push(
            <div className="checkbox-nav" key={y}>
                <label className="checkbox">
                    <span className="checkbox__input">
                        <input
                            type="checkbox"
                            name="checkbox"
                            ref={ref}
                            value={ props.data['content'][y] }
                            defaultChecked={checkbox_from_url.includes(props.data['content'][y])}
                            className='checkbox__field'
                        />
                        <span
                            className="checkbox__control"  >
                            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden="true" focusable="false" fill={props.color}>
                                <path
                                    fill='none'
                                    stroke={`${props.color}`}
                                    strokeWidth='3'
                                    d='M1.73 12.91l6.37 6.37L22.79 4.59' />
                            </svg>
                        </span>
                    </span>
                    <label className="radio__label" htmlFor={id}>
                        { props.data['content'][y] }
                    </label>
                </label>
                {/* <input type="checkbox" name="checkbox" ref={ref} key={y+1} value={props.data['content'][y]} />
                <label> {props.data['content'][y]} </label> */}
            </div>
        )
    }


    return(
        <div className="input-section"  key={props.index}>
            <div className={`checkbox-nav multiple multiple-checkboxes ${props.data['required'] && 'cb-required'}`} id={`parent-${id}`}>
                <label>
                    {props.data['name']}

                    { props.data['required'] && (
                        <span className="required" style={{ color: props.color }}> *</span>
                    )}
                </label>
                <div id={id}>
                    {content}
                </div>
            </div>
        </div>
    )

});

export default MultipleCheckbox;
